import { useState } from 'react'
import { broadcastAnnouncement, broadcastAudience, errorMessage } from '../../../services/admin'
import { broadcastAfterConfirm } from '../confirm'
import { FIELD } from './primitives'

// ─── Broadcast (admin-notifications) ───────────────────────────────────────────

/**
 * One push to every learner at once — a new app version, planned
 * downtime. No target picker on purpose: every `NOTIFICATION_TARGETS`
 * value besides `home` (archive, progress, autopay, feed) means something
 * specific to a per-learner event and would only confuse an admin sending
 * a general announcement; the backend defaults to `home` when the field
 * is omitted. Nothing goes out before the admin has seen the message and
 * how many learners it reaches, and said yes (`broadcastAfterConfirm`).
 */
export function BroadcastForm() {
  const [title, setTitle] = useState('')
  const [body, setBody] = useState('')
  const [busy, setBusy] = useState(false)
  const [err, setErr] = useState('')
  const [result, setResult] = useState(null)

  async function send(e) {
    e.preventDefault()
    setBusy(true); setErr(''); setResult(null)
    try {
      const data = await broadcastAfterConfirm(
        { title: title.trim(), body: body.trim() },
        { audience: broadcastAudience, broadcast: broadcastAnnouncement },
      )
      if (!data) return
      setResult(data)
      setTitle(''); setBody('')
    } catch (ex) { setErr(errorMessage(ex)) }
    finally { setBusy(false) }
  }

  return (
    <form onSubmit={send} className="max-w-xl space-y-3 rounded-xl border border-slate-200 bg-white px-4 py-4 shadow-sm">
      <p className="text-sm font-semibold text-slate-700">ارسال اعلان عمومی</p>
      <p className="text-xs text-slate-500">
        برای همهٔ کاربران در صندوق اعلان ثبت می‌شود؛ اگر پوش روی سرور فعال باشد، روی گوشی هم نشان داده می‌شود.
      </p>
      <label className="block">
        <span className="mb-1 block text-xs font-medium text-slate-600">عنوان</span>
        <FIELD value={title} onChange={e => setTitle(e.target.value)} maxLength={200} required placeholder="نسخهٔ تازهٔ طوطی رسید" />
      </label>
      <label className="block">
        <span className="mb-1 block text-xs font-medium text-slate-600">متن</span>
        <textarea value={body} onChange={e => setBody(e.target.value)} maxLength={500} required rows={3}
          className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:border-brand-500 focus:outline-none"
          placeholder="قابلیت‌های تازه و رفع اشکال. از فروشگاه اپلیکیشن به‌روزرسانی کنید." />
      </label>
      {err && <div className="rounded-lg bg-red-50 px-4 py-3 text-sm text-red-700">{err}</div>}
      {result && (
        <div className="rounded-lg bg-green-50 px-4 py-3 text-sm text-green-700">
          برای {result.recipientCount} کاربر ثبت شد؛ پوش به {result.pushedCount} دستگاه ارسال شد.
        </div>
      )}
      <button type="submit" disabled={busy || !title.trim() || !body.trim()}
        className="rounded-lg bg-brand-600 px-4 py-2 text-sm font-semibold text-white hover:bg-brand-700 disabled:opacity-50">
        {busy ? 'در حال ارسال…' : 'ارسال به همه'}
      </button>
    </form>
  )
}
